import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useGuestStore } from '~/store/guest'
import { useSiteConfigurationStore } from '@/store/siteConfiguration'

export default defineNuxtRouteMiddleware(async (to) => {
  // Ignore devtools requests
  if (to.path.startsWith('/.well-known/') || to.meta.skipMiddleware || import.meta.server) return

  if (to.fullPath === '/' && (!to.query.gift || !to.query.partner)) {
    return navigateTo('/welcome', { external: true })
  }

  const guestStore = useGuestStore()
  const { getSiteConfiguration } = useSiteConfigurationStore()

  if ((guestStore.isCorpPerkStore && !guestStore.guest?.token) || (guestStore.guest?.email && !guestStore.guest?.token)) {
    await Promise.all([
      guestStore.isCorpPerkStore ? guestStore.loginCorpPerkStoreGuestUser() : guestStore.loginGuestUser(),
      getSiteConfiguration(guestStore.gift?.code?.replaceAll('_', ' ') as string),
    ])
  }
  
  if (guestStore.dependents === null && !guestStore.isGuestMode && !guestStore.isCorpPerkStore && !guestStore.isAdminGift) {
    await guestStore.loadDependents()
  }
})
